import {Model} from "./Model";
import {IApiLeagueContestant} from "../typings/apiResponse";

export class LeagueContestant extends Model {
    constructor(private apiData: IApiLeagueContestant) {
        super(apiData);
    }

    public getId(): number {
        return this.apiData.id;
    }

    public getSeed(): number {
        return this.apiData.seed;
    }

    public getStatus(): string {
        return this.apiData.status;
    }

    public getAlias(): string {
        return this.apiData.alias;
    }

    public getName(): string {
        return this.apiData.name;
    }

    public getRegion(): string {
        return this.apiData.region;
    }
}
